<template>
  <div
    class="d-flex flex-row-fluid bgi-size-cover bgi-position-center overlay-layer"
    style="background-image: url('/assets/media/bipart/bg-login.png'); margin-top: -50px;"
  >
    <div class="container">
      <div class="row p-20">
        <div class="col-lg-12">
          <h1 class="mt-10 text-white mb-6 display-4">
            {{$t("MODULEINFO.INPROGRESS")}}
          </h1>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "ModuleInfo",
  data() {
    return {
      id: this.$route.params.id,
      process_id: this.$route.params.process_id,
      phase_id: this.$route.params.phase_id
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("MODULEINFO.ELENCOPROCESSI"), route: "/process-list" },
      { title: this.$t("MODULEINFO.PROCESSO"), route: "/process-detail/" + this.process_id },
      { title: this.$t("MODULEINFO.INFO") }
    ]);
  }
};
</script>

<style scoped></style>
